import * as React from "react";
const SvgCalendar = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.557 1.69V3.752H1.87V22.13H22.13V3.754h-4.686V1.689H15.936v2.064H8.064V1.69h-.753ZM3.379 5.251H20.62v2.246H3.38V6.375Zm0 3.754H20.62v11.616H3.38v-5.81Zm2.055 2.717v1.496h2.822v-1.496h-1.41Zm5.156 0v1.496h2.822v-1.496H12Zm5.164 0v1.496h2.812v-1.496H17.16zm-10.32 4.683v1.498h2.822v-1.498h-1.41Zm5.156 0v1.498h2.822v-1.498H12Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCalendar;
